<footer [ngClass]="{'footer_body': router.url === '/products/detail'}">
  <div class="pt-4 pb-3 main___footer">
    <!-- Desktop version -->
    <div class="container d-none d-lg-block">
      <div class="row">
        <div class="col-lg-2 col-md-12">
          <div class="d-flex align-items-center justify-content-between pb-3">
            <img src="/assets/images/main-logo-white.png" alt="Works with homeXpert" class="img-fluid logo-img">
          </div>
        </div>
      </div>
    </div>

    <hr class="text-grey d-none d-lg-block">

    <div class="container d-none d-lg-block">
      <div class="row border-light-subtle pt-3 align-items-center text-center text-md-start">
        <div class="col-lg-4 mb-2 mb-lg-0">
          <div class="small">
            © 2026 Splendid Minds GmbH
          </div>
        </div>

        <div class="col-lg-4 mb-2 mb-lg-0">
          <div class="d-flex justify-content-center gap-3 opacity-50">
            <a href="https://www.instagram.com/splendidmindsgmbh/" target="_blank" rel="noopener noreferrer" class="text-white"><i class="bi bi-instagram fs-5"></i></a>
            <a href="https://www.youtube.com/@SplendidMinds" target="_blank" rel="noopener noreferrer" class="text-white"><i class="bi bi-youtube fs-5"></i></a>
            <a href="https://www.facebook.com/splendidmindsgmbh" target="_blank" rel="noopener noreferrer" class="text-white"><i class="bi bi-facebook fs-5"></i></a>
            <a href="https://www.linkedin.com/company/splendidminds" target="_blank" rel="noopener noreferrer" class="text-white"><i class="bi bi-linkedin fs-5"></i></a>
          </div>
        </div>

        <div class="col-lg-4 mb-2 mb-lg-0">
          <div class="d-flex justify-content-lg-end justify-content-center gap-5 small">
            <a href="mailto:wwhxp@splendidminds.de">{{ 'footer.contact' | translate }}</a>
            <a routerLink="/datenschutz">{{ 'footer.privacy' | translate }}</a>
            <a routerLink="/impressum">{{ 'footer.imprint' | translate }}</a>
          </div>
        </div>
      </div>
    </div>

    <!-- Mobile + Tablet version -->
    <div class="container d-block d-lg-none text-center py-4 mobile-footer">
      <div class="mb-3">
        <img src="/assets/images/main-logo-white.png" alt="Works with homeXpert" class="img-fluid" style="max-width:140px;">
      </div>
      <nav class="d-flex flex-column gap-2 align-items-center mb-3">
        <a href="mailto:wwhxp@splendidminds.de">{{ 'footer.contact' | translate }}</a>
        <a routerLink="/datenschutz">{{ 'footer.privacy' | translate }}</a>
        <a routerLink="/impressum">{{ 'footer.imprint' | translate }}</a>
      </nav>
      <div class="d-flex justify-content-center gap-3 opacity-50 mb-3">
        <a href="https://www.instagram.com/splendidmindsgmbh/" target="_blank" rel="noopener noreferrer" class="text-white"><i class="bi bi-instagram fs-5"></i></a>
        <a href="https://www.youtube.com/@SplendidMinds" target="_blank" rel="noopener noreferrer" class="text-white"><i class="bi bi-youtube fs-5"></i></a>
        <a href="https://www.facebook.com/splendidmindsgmbh" target="_blank" rel="noopener noreferrer" class="text-white"><i class="bi bi-facebook fs-5"></i></a>
        <a href="https://www.linkedin.com/company/splendidminds" target="_blank" rel="noopener noreferrer" class="text-white"><i class="bi bi-linkedin fs-5"></i></a>
      </div>
      <div class="small">
        © 2026 Splendid Minds GmbH
      </div>
    </div>
  </div>
</footer>
